import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { GraphUpArrow, TagFill } from 'react-bootstrap-icons';
import { useTranslation } from '../../i18n';
import { AppContext } from '../../window';

interface ExitIntentPopupProps {
    onStay: () => void;
}

const ExitIntentPopup: React.FC<ExitIntentPopupProps> = ({ onStay }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [hasShown, setHasShown] = useState(false);
    const { location } = useContext(AppContext);

    useEffect(() => {
        const handleMouseLeave = (e: MouseEvent) => {
            // Only trigger on desktop when mouse leaves viewport from top
            if (!hasShown && e.clientY <= 0 && window.innerWidth > 768) {
                setShow(true);
                setHasShown(true);
            }
        };

        // Add slight delay before activating to avoid immediate triggers
        const timer = setTimeout(() => {
            document.addEventListener('mouseleave', handleMouseLeave);
        }, 3000);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [hasShown]);

    const handleStay = () => {
        setShow(false);
        onStay();
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            centered
            size="lg"
            backdrop="static"
        >
            <Modal.Body className="text-center p-5">
                <TagFill size={60} className="text-danger mb-3" />
                
                <h2 className="mb-3 fw-bold">
                    {t('landing.exit_popup_title')}
                </h2>
                
                <p className="lead mb-4">
                    {t('landing.exit_popup_offer_get')} <span className="text-danger fw-bold">{t('landing.exit_popup_discount')}</span> {t('landing.exit_popup_offer_month')}
                    <br />
                    {t('landing.exit_popup_urgency')}
                </p>

                <div className="bg-body-tertiary rounded p-3 mb-4">
                    <GraphUpArrow className="text-success me-2" />
                    <span className="fw-bold">{t('landing.exit_popup_people_count')}</span> {t('landing.exit_popup_from')} {location?.town?.name || t('landing.exit_popup_your_area')} {t('landing.exit_popup_joined_today')}
                </div>

                <div className="d-grid gap-2">
                    <Button 
                        variant="success" 
                        size="lg"
                        onClick={handleStay}
                        className="fw-bold"
                    >
                        {t('landing.exit_popup_claim_discount')}
                    </Button>
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleClose}
                    >
                        {t('landing.exit_popup_decline')}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ExitIntentPopup;